module.exports = __webpack_public_path__ + "img/fullOutline.3ef2a2d4.svg";